import * as z from 'zod';

// Schema for service form validation
export const serviceFormSchema = z.object({
  id: z.number().optional(),
  serTitle: z.string().min(1, 'Title is required'),
  serDescription: z.string().min(1, 'Description is required'),
  serStation: z.string().optional().default(''),
  serCredit: z.number({ required_error: 'Credit is required', invalid_type_error: 'Credit must be a number' }),
  serSupply: z.number({ required_error: 'Supply is required' }).min(0, 'Supply must be positive'),
  serStatus: z.boolean().default(false),
  serAmount: z.number().min(0, 'Amount must be positive').optional(),
  serNote: z.string().optional().default(''),
  serCategory: z.array(z.string()).min(1, 'At least one category is required'),
  serSpecialCategory: z.array(z.string()).default([]),
  serAvatar: z.object({
    shape: z.string(),
    color1: z.string(),
    color2: z.string(),
  }).optional(),
  position: z.number().min(0, 'Position must be positive').default(0),
});

export type ServiceFormValues = z.infer<typeof serviceFormSchema>;
